import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Swords } from 'lucide-react';
import { useState } from 'react';

export const DebateSettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Swords className="w-5 h-5 text-primary" />
          <CardTitle>deBattle</CardTitle>
        </div>
        <CardDescription>
          Administrer debatt- og argumentasjonsfunksjoner
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="debate-enabled">Aktivert</Label>
          <Switch
            id="debate-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>Debattregler</Label>
          <p className="text-sm text-muted-foreground">
            Sett opp regler for debatter, maks antall argumenter og moderering.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
